/* eslint-disable max-len */
// react
import React from "react";

import Button from "../../components/Button";
// components
import Text from "../../components/Text";
// config
import Config from "./Config";

// styles
import css from "./ErrorPage.module.scss";

type ErrorPageProps = {
	code?: number;
	title?: string;
	description?: string;
};

const ErrorPage = ({ code = 404, title, description }: ErrorPageProps) => {
	if (!Config.content[code] && (!title || !description)) {
		return null;
	}

	return (
		<div className={css.main}>
			<div className={css.contentContainer}>
				<div className={css.logoContainer}>
					<img src="https://performyard-content.performyard.com/static/img/py-logo/py-logo-and-text-large.png" />
				</div>

				<div className={css.textContainer}>
					<div className={css.textContent}>
						<Text size="heading-3" weight="bold">
							{title || Config.content[code].title}
						</Text>
						<Text className={css.description} size="paragraph-1" weight="regular">
							{description || Config.content[code].description()}
						</Text>
					</div>
				</div>

				<Button className={css.backButton} href="/" forceHardReload={true}>
					Take Me Back
				</Button>
			</div>
		</div>
	);
};

export default ErrorPage;
